var map = {
	"./Instyle.png": 7345,
	"./allrecipes.png": 8478,
	"./allyou.png": 1506,
	"./betterhomesgardens.png": 2248,
	"./business.png": 5526,
	"./coastalliving.png": 4104,
	"./cookinglight.png": 3316,
	"./countrygardens.png": 7596,
	"./diabeticliving.png": 3844,
	"./doityourself.png": 2207,
	"./eatingwell.png": 510,
	"./entertainment.png": 4748,
	"./familycircle.png": 5328,
	"./finecooking.png": 8890,
	"./foodwine.png": 7303,
	"./health.png": 5146,
	"./homepage.png": 4232,
	"./homesgardens.png": 2870,
	"./life.png": 5834,
	"./magnolia.png": 2690,
	"./marthastewart.png": 1057,
	"./midwestliving.png": 282,
	"./millie.png": 9444,
	"./parents.png": 7449,
	"./parentsLatina.png": 3602,
	"./people.png": 1594,
	"./peopleenspanol.png": 2921,
	"./peoplestyle.png": 8222,
	"./rachaelray.png": 8208,
	"./realsimple.png": 5538,
	"./reveal.png": 3143,
	"./shape.png": 6453,
	"./southernliving.png": 5731,
	"./successfulfarming.png": 6740,
	"./traditionalhome.png": 7072,
	"./travelleisure.png": 9879,
	"./wood.png": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5178;